import { useState } from "react";
// import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import "./Login.css";
import ModalLogin from "react-modal";
import ModalRegister from "react-modal";
import CloseIcon from "@material-ui/icons/Close";
import { addLogin } from "../../redux/action/addLogin";
import { addRegister } from "../../redux/action/addRegister";

// import { useHistory } from "react-router-dom";

import { register, login } from "../../services/userService";

const Login = () => {
  const [email, setEmail] = useState("");
  const [emailRg, setEmailRg] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRg, setPasswordRg] = useState("");
  const [fullnameRg, setFulnameRg] = useState("");
  const [usernameRg, setUsernameRg] = useState("");
  const profile_picRg = "";

  const [regmod, setRegmod] = useState(true);
  const [loginmod, setLoginmod] = useState(false);

  const dispatch = useDispatch();
  // const history = useHistory();

  const handlerRegister = e => {
    console.log("click");
    e.preventDefault();
    const store = window.localStorage;
    register(fullnameRg, usernameRg, emailRg, passwordRg, profile_picRg)
      .then(response => {
        const { id, email, userName, profile_pic } = response.data;
        console.log(response, "register");
        const temp = { id, email, userName, profile_pic };
        store.setItem("user", JSON.stringify(temp));
        dispatch(addRegister(id, email, userName, profile_pic));
      })
      .catch(error => {
        console.log(error);
      });
    setRegmod(false);
    setLoginmod(true);
  };

  const handleSubmit = e => {
    e.preventDefault();
    const store = window.localStorage;
    login(email, password)
      .then(response => {
        console.log(response, "login");
        const { id, name, email, userName, role, token } = response.data;
        console.log(response.data);
        const temp = { id, name, email, userName, role, token };
        store.setItem("user", JSON.stringify(temp));
        dispatch(addLogin(id, name, email, userName, role, token));
      })
      .catch(error => {
        console.log(error);
      });
    setLoginmod(false);
    // history.push("");
  };

  const customStyles = {
    content: {
      height: "50vh",
      width: "25vw",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  return (
    <div className="pagar">
      <>
        <ModalRegister
          isOpen={regmod}
          style={customStyles}
          onRequesClose={e => {
            e.preventDefault();
            setRegmod(true);
          }}
        >
          <div className="section">
            <div className="container">
              <form className="form">
                <h3>Milan TV</h3>

                {/* <h6>Full Name</h6> */}
                <input
                  type="fullname"
                  onChange={e => setFulnameRg(e.target.value)}
                  placeholder="Full Name"
                  value={fullnameRg}
                  // name="name"
                ></input>
                {/* <h6>User Name</h6> */}
                <input
                  type="username"
                  onChange={e => setUsernameRg(e.target.value)}
                  placeholder="User Name"
                  value={usernameRg}
                  // name="name"
                ></input>

                {/* <h6>Email</h6> */}
                <input
                  type="text"
                  // name="email"
                  value={emailRg}
                  placeholder="Your email here"
                  onChange={e => setEmailRg(e.target.value)}
                ></input>

                {/* <h6>Password</h6> */}
                <input
                  type="password"
                  // name="password"
                  value={passwordRg}
                  placeholder="Password"
                  onChange={e => setPasswordRg(e.target.value)}
                ></input>

                <div className="btn-sign" onClick={handlerRegister}>
                  Sign Up
                </div>

                <p>
                  Already have an account?
                  <button
                    className="btn-signinfa"
                    onClick={() => {
                      setRegmod(false);
                      setLoginmod(true);
                    }}
                  >
                    Log In
                  </button>
                </p>
                {/*  */}
              </form>
            </div>
            <span onClick={() => setRegmod(false)}>
              <CloseIcon size="small" />
            </span>
          </div>
        </ModalRegister>

        <ModalLogin
          style={customStyles}
          isOpen={loginmod}
          onRequestClose={e => {
            e.defaultPrevented();
            setLoginmod(true);
          }}
        >
          <div className="section">
            <div className="container">
              <form className="form" onSubmit={handleSubmit}>
                <h3>Milan TV</h3>
                {/* <h6>Email</h6> */}
                <input
                  type="username"
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Username"
                  value={email}
                  // name="name"
                ></input>

                {/* <h6>Password</h6> */}
                <input
                  type="password"
                  // name="password"
                  value={password}
                  placeholder="Password"
                  onChange={e => setPassword(e.target.value)}
                ></input>

                <button className="btn-sign">Log in</button>
              </form>
            </div>
            <span onClick={() => setLoginmod(false)}>
              <CloseIcon size="small" />
            </span>
          </div>
        </ModalLogin>
      </>
    </div>
  );
};

export default Login;
